import styled, { css } from 'styled-components';

export const SaveCodeContainer = styled.div`
    position: relative;

    flex: 1;
    display: flex;
    flex-direction: row;
    align-items: center;

    align-self: stretch;
    justify-content: center;

    margin-top: 25px;

    transition: all 0.2s linear;

    > .select-save-code {
        > input {
            display: none;
        }
        height: 40px;

        flex: 1;

        display: flex;
        align-items: center;
        justify-content: flex-start;
        flex-direction: row;

        text-transform: uppercase;
        font-size: 1.8rem;
        color: #fff;
        white-space: nowrap;

        user-select: none;

        cursor: pointer;

        transition: all 5s linear;

        > .label-checkbox {
            line-height: 18px;
            align-self: center;
        }
    }

    > input {
        display: none;

        transition: all 0.2s linear;
    }

    &::before {
        content: '';
        position: absolute;
        bottom: 0px;
        left: 50%;
        right: 50%;

        height: 2px;
        background: #fff;

        transition: all 0.2s linear;
    }

    ${props =>
        props.nameCode &&
        css`
            &::before {
                left: 0;
                right: 0;
            }

            > input {
                display: block
                width: 100%;
                line-height: 40px;

                text-align: center;
                text-transform: uppercase;
                font-size: 2.4rem;
                font-weight: 100;
                color: #fff;

                padding: 0 15px;

                border: 0;
                background: transparent;

                &::placeholder {
                    color: rgba(255, 255, 255, 0.6);
                    font-size: 2.4rem;
                    font-weight: 100;
                }
            }
        `}
`;
export const Checkbox = styled.span`
    width: 18px;
    height: 18px;

    display: flex;
    align-items: center;
    justify-content: center;

    border: 1px solid ${props => (props.checked ? '#03a9f4' : '#fff')};
    border-radius: 5px;

    background-color: ${props => (props.checked ? '#03a9f4' : '#d4d4d4')};

    margin-right: 8px;

    svg {
        display: ${props => (props.checked ? 'block' : 'none')};
    }
`;
